import http from "../../http";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import DecoinInterface from "./decoins_interface";
import { DecoinLimit } from "../../../../domain/entities/decoins";

class DecoinRepository implements DecoinInterface {
  async dailyDecoinLimit(): Promise<DecoinLimit> {
    return wrapErrorHandler<DecoinLimit>(async () => {
      const response = await http.get(`/api/decola/decoinsMaxDaily`);
      return response.data;
    });
  }

  async decoinDailyLimitMessageAccepted(): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      return await http.post(`/api/decola/decoins/accept`);
    });
  }
}

export default new DecoinRepository() as DecoinInterface;
